/**
 * This function is used for legacy reasons, it replaces some characters in the input value
 * @param value - the input value from the user
 * @returns the revised input value
 */
export function legacyFilter(value: string) {
  if (/[—‘’]/.test(value)) {
    if (value.indexOf("—") !== -1) {
      value = value.replace("—", "--")
    }
    if (value.indexOf("‘") !== -1) {
      value = value.replace("‘", "'")
    }
    if (value.indexOf("’") !== -1) {
      value = value.replace("’", "'")
    }
  }
  return value
}
